import React, {Component} from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import {extractErrorMessage} from '../utils';

export default class Error extends Component {
    static propTypes = {
        error: PropTypes.any,
        stackTrace: PropTypes.string
    };

    state = {
        showDetails: false
    };

    render() {
        const {error, stackTrace} = this.props;
        if (isEmpty(error)) {
            return false;
        }
        const errorMessage = extractErrorMessage(error) || 'Unknown error';
        let stackTraceControl;
        if (!isEmpty(stackTrace)) {
            let detailsControl;
            if (this.state.showDetails) {
                detailsControl = <pre>{stackTrace}</pre>;
            }
            const handleClick = (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.setState({showDetails: !this.state.showDetails});
            };
            stackTraceControl = <div><a onClick={handleClick}>{'More details ... '}</a>{detailsControl}</div>;
        }
        return (<div className="alert alert-danger">{errorMessage}{stackTraceControl}</div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/Error.js